import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { State } from '../../../../core/store';
import { Store } from '@ngrx/store';
import { EmployeeHrNoteModel } from '../../../../models/employeeReviewModels';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { closeEditEmployeeNote, getEmployeeHrNotes, saveEmployeeNote, saveEmployeeNoteSuccess } from '../../../../core/store/employee-review/employee-review.actions';
import { markFormGroupTouched, updateFormGroupValidity } from '../../../../helpers/utils';

@Component({
    selector: 'app-edit-employee-notes',
    templateUrl: './edit-employee-notes.component.html',
    styleUrls: ['./edit-employee-notes.component.scss'],
    standalone: false
})
export class EditEmployeeNotesComponent extends BaseComponent implements OnInit {
  display: boolean = false;
  title: string = "Add HR Note";
  form: UntypedFormGroup;
  disableButtons: boolean = true;

  Notes: EmployeeHrNoteModel[] = [] as EmployeeHrNoteModel[];


  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.form = this.createForm();
    this.subs.push(
      this.store.select(s => s.employeeReviewState.editingEmployeeHrNote).subscribe(editing => {
        if (!editing) {
          //need to reset form
          this.resetForm();
        }
        this.display = editing;
      }),
      this.store.select(s => s.employeeReviewState.savingEmployeeHrNote).subscribe(saving => {
        this.disableButtons = saving;
      }),
      this.store.select(s => s.employeeReviewState.hrNoteEmployeeId).subscribe(employeeId => {
        var id = employeeId != null ? employeeId : 0;
        if (id > 0) {
          this.store.dispatch(getEmployeeHrNotes({ employeeId: id }));
        }
        //need to update with model if UI allows editing the HR note. As of now, only allow adding a new note
        this.form.get("employeeId").setValue(id);

      }),
      this.store.select(s => s.employeeReviewState.hrNotes).subscribe(notes => {
        if (notes && notes.length > 0) {
          this.Notes = notes;
          console.log(this.Notes);
        }
      }),
      this.actions$.pipe(
        ofType(saveEmployeeNoteSuccess),
        tap(action => {
          this.closeModal();          
        })
      ).subscribe()
    );
  }

  resetForm() {
    //clear all fields except for employee ID which is set from employee review state
    this.form.get("note").setValue("");
    this.Notes = [] as EmployeeHrNoteModel[];
  }

  createForm() {
    let f = this.fb.group({
      hrNoteId: this.fb.control(0),
      employeeId: this.fb.control(0),
      writtenByUserId: this.fb.control(0),
      date: this.fb.control(new Date()),
      note: this.fb.control(""),
      writtenByName: this.fb.control(""),
      employeeName: this.fb.control("")
    });

    return f;
  }

  closeModal() {
    this.store.dispatch(closeEditEmployeeNote());
  }

  saveEmployeeHrNote() {
    updateFormGroupValidity(this.form);
    if (this.form.valid) {
      this.store.dispatch(saveEmployeeNote({ hrNote: this.form.value as EmployeeHrNoteModel }));
    }
    else {
      markFormGroupTouched(this.form);
    }
  }

}
